export default __webpack_public_path__ + "static/media/Inter-ExtraLightItalic.dd7136ac.woff";